import React, {useEffect} from "react";
import {Redirect, Route, Switch, useLocation,} from "react-router-dom";
import {SettingsPage} from "../features/settings";
import {TakeoffsRouter} from "../features/project-list";
import {initWalkMe, removeWalkMe} from "../utils/WalkMeUtils";
import {useUpdatedRef} from "../hooks/useUpdatedRef";
import {pages, paths, useNavigator} from "../features/navigator";
import {useMeDataContext} from "../providers/MeProvider";
import {initializePendo} from "../utils/PendoUtils";

const MainRouter: React.FC = () => {

	const {navigateTo} = useNavigator()
	const {user} = useMeDataContext()
	const locationSearch = useLocation().search
	const dataRef = useUpdatedRef({locationSearch, navigateTo})

	useEffect(() => {
		initWalkMe();
		return removeWalkMe;
	}, [])

	// Mirrors app-v2's SessionKeepAlive: keyed on the two primitives so Pendo is never re-initialized
	// if `user` is ever re-created for the same person, and skipped entirely if either is missing.
	const simproUrl = user?.simproUrl
	const simproUserId = user?.simproUserId
	useEffect(function pendoIdentify() {
		if (simproUrl === undefined || simproUserId === undefined) return
		initializePendo({simproUrl, simproUserId})
	}, [simproUrl, simproUserId])

	useEffect(function urlParamRedirect() {
		const {locationSearch, navigateTo} = dataRef.current
		const query = new URLSearchParams(locationSearch)

		if (query.has("q")) {
			navigateTo(pages.simproIdQuotePage(query.get("q")!))
		}
		if (query.has("j")) {
			navigateTo(pages.simproIdJobPage(query.get("j")!))
		}
	}, [dataRef]);

	return (
		<Switch>
			<Route path={paths.settings} component={SettingsPage}/>
			<Route path={paths.takeoffs} component={TakeoffsRouter}/>
			<Redirect to={paths.takeoffs}/>
		</Switch>
	);
};

export {MainRouter}
